var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8AA5AF",
    d: "M8,15.4882812 C10.0625,15.4882812 11.8261719,14.7558594 13.2910156,13.2910156 C14.7558594,11.8261719 15.4882812,10.0625 15.4882812,8 C15.4882812,5.9375 14.7558594,4.17382812 13.2910156,2.70898438 C11.8261719,1.24414062 10.0625,0.51171875 8,0.51171875 C5.9375,0.51171875 4.16796875,1.25 2.69140625,2.7265625 C1.23828125,4.1796875 0.51171875,5.9375 0.51171875,8 C0.51171875,10.0625 1.24414062,11.8261719 2.70898438,13.2910156 C4.17382812,14.7558594 5.9375,15.4882812 8,15.4882812 Z M6.48828125,11.7617188 L2.76171875,8 L3.81640625,6.9453125 L6.48828125,9.6171875 L12.1835938,3.921875 L13.2382812,5.01171875 L6.48828125,11.7617188 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCircle);
export default __webpack_public_path__ + "static/media/checked-circle.8f7db79ef2ddf6bdb4f0ff4488b9ef8a.svg";
export { ForwardRef as ReactComponent };